// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2FcSY","description":"PatientConsentPreview_description__1Dch1"};